// extracted by mini-css-extract-plugin
module.exports = {"actions":"OrderItemsList_actions__q5iZ6","status":"OrderItemsList_status__0xIYK"};